/* eslint-disable */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  checkIsNA,
  convertStringToArrayForOption,
  loadIfStateAvailableInSessionStorage
} from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Checkbox from '../../../common/Checkbox';
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../common/PersistLink';
import Radiobutton from '../../../common/Radio/radioButton';
import SimpleDropdown from '../../../common/SimpleDropdown';
import SweepFrequencyPicker from '../../../common/SweepFrequencyPicker';
import GlsNotionalPoolingBasicDetails from './GlsNotionalPoolingBasicDetails';
import GlsNotionalPoolingStrucutre from './GlsNotionalPoolingStrucutre';

//dummy data
//import {reportedEChannelId} from '../CaptureProductGlsInterestEnhancement/Dummy/reportedEChannelId';

//import GlsNotionalPoolingInterestOptimization  from './GlsNotionalPoolingInterestOptimization';
//action Creator
import {
  interestPeriodSettlementDate,
  resetPoolIdAfterSaveReferesh,
  setBasicDetailAcc,
  setFormDataInterestOptimization,
  setPageJson,
  setPageJson1,
  setPageJson2,
  setPageJsonAccordian,
  setPartyCurrency,
  setProductNotionalPooling,
  setStatus
} from './actions/actionCreator';
//style
import classNames from 'classnames';
import CCRRateBox from '../../../common/CCRRateBox';
import './OtherSetting.css';
import './index.css';

class CaptureProductGlsNotionalPooling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formRef: {},
      noOfReporting: 1,
      reportedEChannelId: '',
      eChannelReported: '',
      dataReady: false,
      notionalPoolingTitle: "",
      interestOptimisations: [],
      isdeletePool: false,
      isdeleteStandAlone: false,
      currentDeletePoolId: '',
      baseCurrency: [],
      selectedBaseCurrency: '',
      unauthorizedInterestTypeFloating: this.props.notionalPoolingdata.notionalPooling !== undefined && this.props.notionalPoolingdata.notionalPooling.otherSettings !== undefined && this.props.notionalPoolingdata.notionalPooling.otherSettings.unauthorizedInterestTypeFixed !== undefined ? this.props.notionalPoolingdata.notionalPooling.otherSettings.unauthorizedInterestTypeFixed : true,
      unauthorizedInterestTypeFixed: '',
      checkODLimit: true,
      odLimit: 'N/A',
      isIERequired: undefined,
      showIntersetOptimization: false,
      unauthorisedOD: this.getInitialUnauthorisedODObject(),
      frequencyInfo: this.props.notionalPoolingdata.notionalPooling && this.props.notionalPoolingdata.notionalPooling.otherSettings &&
        this.props.notionalPoolingdata.notionalPooling.otherSettings.frequencyInfo ? this.props.notionalPoolingdata.notionalPooling.otherSettings.frequencyInfo : this.getFrequencyInfoInitialValues(),
      // isloadSweep: false,
      poolID: undefined,
      standID: undefined
    }
    this.reportingEchannelDisableList = []
    this.renderInterestOptimization = this.renderInterestOptimization.bind(this);
    let { caseId, productId } = this.props.match.params;
    this.payload = new NotionalPoolingPayload()
    this.payloadBasicDetail = new basicDetailPayload();
    this.payloadOtherSetting = new otherSettingPayload();
    this.payloadInterestOptimization = new interestOptimizationPayload();
    this.payloadEchannelReportingSection = new EchannelReportingSection();
    this.dataDictionaryURI = `/product/taxonomies/interestPeriodSettlementDate`;
    this.apiURL = `/product/gls/${this.props.notionalPoolingdata.id}`;
    this.apiURL = "/product/gls/" + productId;
    this.apiURLPartyCurrency = `/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency`;
    this.apiURLBasicDetailAcc = `/product/gls/${productId}/case/${caseId}/account/`;
    this.apiURLDeletePool = `/product/gls/notionalPool/${productId}/cancelPool/`;
    this.apiURLNPFromJson = "/aemData/formData/json_notional-pooling-all-closed";
    this.apiURLPageJson = "/aemData/formData/json_notional-pooling-page";
    this.apiURLPageJson1 = "/aemData/formData/json_pooling-structure";
    this.apiURLPageJson2 = "/aemData/formData/json_other-settings";
    this.apiURLNPInterstOptimization = "/aemData/formData/json_gls-interest-optimisation";
    this.apiURLDeleteStandAlone = `/product/gls/notionalPool/${productId}/cancelPool/`;
    this.apiURLModal = "/aemData/formData/json_notionla-pooling-modal-page";
    //  this.interestPeriodSettlementDate = `/product/taxonomies/interestPeriodSettlementDate/`;
  }

  loadPageState = () => {
    /*api call for Notaionl Pooling Data*/
    eapiClient(this.apiURL, { method: 'GET' })
      .then(({ data }) => {
        if (data.responseData) {
          this.props.setProductNotionalPooling(data.responseData);
          if (data.responseData && data.responseData.notionalPooling) {
            if (data.responseData.notionalPooling.isIERequired === undefined) {
              data.responseData.notionalPooling.isIERequired = undefined
            }

            this.setState({
              dataReady: true,
              notionalPoolingTitle: this.props.notionalPoolingdata.notionalPoolingTitle,
              interestOptimisations: data.responseData.notionalPooling.interestOptimisations,
              eChannelReported: typeof data.responseData.notionalPooling.eChannelReported == "boolean" ? data.responseData.notionalPooling.eChannelReported : '',
              reportedEChannelId: data.responseData.notionalPooling.reportedEChannelId,
              isIERequired: data.responseData.notionalPooling.isIERequired
            }, () => {
              var localObj = {
                name: 'EChannelReporting',
                values: this.state
              }
              this.payload.setPaylod(localObj);
            })
            this.reportingEchannelDisableList = data.responseData.notionalPooling.reportedEChannelId !== undefined && data.responseData.notionalPooling.reportedEChannelId !== null ?
              data.responseData.notionalPooling.reportedEChannelId : []

            if (Object.keys(data.responseData.notionalPooling.otherSettings).length > 0 && typeof data.responseData.notionalPooling.otherSettings !== 'undefined') {
              this.setState({
                unauthorizedInterestTypeFixed: data.responseData.notionalPooling.otherSettings.unauthorizedInterestTypeFixed,
                unauthorizedInterestTypeFloating: data.responseData.notionalPooling.otherSettings.unauthorizedInterestTypeFloating,
                unauthorisedOD: data.responseData.notionalPooling.otherSettings.unauthorisedOD || this.getInitialUnauthorisedODObject(),
                selectedBaseCurrency: 'baseCurrency' in data.responseData.notionalPooling.otherSettings ? data.responseData.notionalPooling.otherSettings.baseCurrency.name : '',
                frequencyInfo: data.responseData.notionalPooling.otherSettings.frequencyInfo || this.getFrequencyInfoInitialValues(),
                odLimit: data.responseData.notionalPooling.otherSettings.odLimit ? checkIsNA(data.responseData.notionalPooling.otherSettings.odLimit) : 'N/A',
                checkODLimit: data.responseData.notionalPooling.otherSettings.odLimit ? checkIsNA(data.responseData.notionalPooling.otherSettings.odLimit, true) : true,
              })
              this.setMyValue()
            } else {
              this.setState({
                unauthorizedInterestTypeFixed: '',
                unauthorizedInterestTypeFloating: true,
                checkODLimit: true,
                odLimit: 'N/A',
                unauthorisedOD: this.getInitialUnauthorisedODObject(),
                frequencyInfo: this.getFrequencyInfoInitialValues()
              })
            }
            this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
          }
        }
      });
  }

  componentWillMount() {
    /*api call for form json*/
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });
  }

  componentDidMount = () => {
    aemHostClient(this.apiURLNPFromJson)
      .then(({ data }) => {
        this.setState({
          formJson: data
        });
        this.getInterestPeriodSettlementDate();
        this.props.setPageJsonAccordian(data.par.dynamic_accordion_list_notionalpooling);
      });


    /*api call for Notaionl pageJSON*/

    aemHostClient(this.apiURLPageJson1)
      .then(({ data }) => {
        if (data.par !== 'undefined' && data.par.staticText_notionalPooling !== 'undefined') {
          //this.setState({pageJson: data.par.notional_pooling});
          this.props.setPageJson1(data.par.staticText_notionalPooling);
        }
      });

    aemHostClient(this.apiURLPageJson2)
      .then(({ data }) => {
        if (data.par !== 'undefined' && data.par.staticText_otherSettings !== 'undefined') {
          //this.setState({pageJson: data.par.notional_pooling});
          this.props.setPageJson2(data.par.staticText_otherSettings);
        }
      });

    aemHostClient("/aemData/formData/json_gls_echannel_reporting")
      .then(({ data }) => {
        this.setState({
          json_echannelReporting: data.par
        });
      });

    aemHostClient(this.apiURLModal)
      .then(({ data }) => {
        this.setState({
          modalData: data.par
        })
        //this.props.setModalData(data.responseData)
      })

    this.loadTabStatus();

    /*api call for apiURLPartyCurrency*/
    taxonomyHostClient(this.apiURLPartyCurrency, { method: 'GET' })
      .then(({ data }) => {
        this.props.setPartyCurrency(data.responseData);
      });

    /*api call for  Basic details account*/
    eapiClient(this.apiURLBasicDetailAcc, { method: 'GET' })
      .then(({ data }) => {
        this.props.setBasicDetailAcc(data.responseData);
      });

    // eapiClient(this.interestPeriodSettlementDate,{  method:'GET'})
    // .then(({data}) => {
    //       this.props.interestPeriodSettlementDate(data.responseData);
    // });
    let caseId = this.props.match.params.caseId;
    eapiClient("/product/caseRelatedEchannel/case/" + caseId)
      .then(({ data }) => {
        this.setState({
          eChannels: data.responseData
        }, () => {
          this.getInterestPeriodSettlementDate();
        })
      });
    /*api call for Notaionl Pooling Data*/
    eapiClient(this.apiURL, { method: 'GET' })
      .then(({ data }) => {
        this.props.setProductNotionalPooling(data.responseData);
        // if (data.responseData.notionalPooling.isIERequired === undefined) {
        //   data.responseData.notionalPooling.isIERequired = undefined
        // }
        if (data.responseData && data.responseData.notionalPooling && this.props.notionalPoolingdata && this.props.notionalPoolingdata.notionalPooling) {
          this.setState({
            dataReady: true,
            notionalPoolingTitle: this.props.notionalPoolingdata.notionalPoolingTitle,
            interestOptimisations: this.props.notionalPoolingdata.notionalPooling.interestOptimisations || [],
            isIERequired: data.responseData.notionalPooling.isIERequired
          })

          if (Object.keys(data.responseData.notionalPooling.otherSettings).length > 0 && typeof data.responseData.notionalPooling.otherSettings !== 'undefined' &&
            typeof data.responseData.notionalPooling.otherSettings.odLimit === "string") {
            this.setState({
              unauthorizedInterestTypeFixed: data.responseData.notionalPooling.otherSettings.unauthorizedInterestTypeFixed,
              unauthorizedInterestTypeFloating: data.responseData.notionalPooling.otherSettings.unauthorizedInterestTypeFloating,
              unauthorisedOD: data.responseData.notionalPooling.otherSettings.unauthorisedOD || this.getInitialUnauthorisedODObject(),
              selectedBaseCurrency: 'baseCurrency' in data.responseData.notionalPooling.otherSettings ? data.responseData.notionalPooling.otherSettings.baseCurrency.name : '',
              frequencyInfo: data.responseData.notionalPooling.otherSettings.frequencyInfo,
              odLimit: data.responseData.notionalPooling.otherSettings.odLimit ? data.responseData.notionalPooling.otherSettings.odLimit : 'N/A',
              checkODLimit: data.responseData.notionalPooling.otherSettings.odLimit ? checkIsNA(data.responseData.notionalPooling.otherSettings.odLimit, true) : true
            })
            this.setMyValue()
          } else {
            this.setState({
              unauthorizedInterestTypeFixed: '',
              unauthorizedInterestTypeFloating: true,
              checkODLimit: true,
              odLimit: 'N/A',
              unauthorisedOD: this.getInitialUnauthorisedODObject(),
              frequencyInfo: {
                timeZone: null,
                frequencyType: {
                  name: "Monthly",
                  value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
                },
                frequencyDetails: {
                  name: null,
                  value: null
                },
                frequencyDetailValue: {
                  name: null,
                  value: null
                },
                annualDate: null,
                dates: []
              }
            })
          }
          this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
        }
        if (data.responseData !== undefined) {
          var poolID = [], standID = [];
          if (data.responseData.notionalPooling !== undefined && data.responseData.notionalPooling.poolingStructure !== undefined && data.responseData.notionalPooling.poolingStructure.pools !== null) {
            poolID = data.responseData.notionalPooling.poolingStructure.pools.map(item => item.id)
          }
          if (data.responseData.notionalPooling !== undefined && data.responseData.notionalPooling.poolingStructure !== undefined && data.responseData.notionalPooling.poolingStructure.standAloneAccount !== null) {
            standID = data.responseData.notionalPooling.poolingStructure.standAloneAccount.map(item => item)
          }
          var allAcc = data.responseData.notionalPooling !== undefined && data.responseData.notionalPooling.interestOptimisations !== undefined ? data.responseData.notionalPooling.interestOptimisations : [];
          if ((allAcc !== undefined && allAcc !== null) && (poolID !== undefined || standID !== undefined)) {
            var myPool = allAcc.filter((item) => poolID.includes(item.id));
            var myStand = allAcc.filter((item) => standID.includes(item.id));
            this.setState({
              poolID: myPool,
              standID: myStand
            })
          }
        }
        if (data.responseData !== undefined && this.props.currency !== undefined) {
          if (this.props.poolIdAfterSaveRefresh !== undefined) {
            this.props.resetPoolIdAfterSaveReferesh();
          }
          let standAloneAccount = (data.responseData.notionalPooling && data.responseData.notionalPooling.poolingStructure && data.responseData.notionalPooling.poolingStructure.standAloneAccount) || [];
          let pools = (data.responseData.notionalPooling && data.responseData.notionalPooling.poolingStructure && data.responseData.notionalPooling.poolingStructure.pools) || [];
          let accounts = data.responseData.otherAccounts;
          let currency = this.props.currency;
          let baseCurrency = [];
          //var distinctCurrnecies = [];
          //var unique = {};
          // if (typeof data.responseData.notionalPooling.otherSettings.frequencyInfo !== 'undefined' && Object.keys(data.responseData.notionalPooling.otherSettings.frequencyInfo).length > 0) {
          //   this.setState({
          //     isloadSweep: true
          //   })
          // }

          standAloneAccount.map((standAloneId) => {
            accounts.filter((item) => {
              if (standAloneId === item.id) {
                baseCurrency.push(item.currency);
              }
            });
          });

          pools.map((currencyVal) => {
            if (typeof currencyVal.poolCurrency !== 'undefined') {
              let currencyNew = currencyVal.poolCurrency;
              currency.classificationNodes.filter((item) => {
                if (currencyNew.name === item.name) {
                  let obj = {
                    name: item.name,
                    value: item.id
                  }
                  baseCurrency.push(obj);
                }
              });
            }
          });

          this.setState({
            baseCurrency: this.removeDuplicates(baseCurrency, 'value')
          })

        }
      });
    this.loadTabStatus();

    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }

    if (getCurrentDropDownName === 'eChannelReporting' || getCurrentDropDownName === 'accountSignatories') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }
    var _eChannelReporting = this.state.reportedEChannelId;

    if (getCurrentDropDownName === 'eChannelReporting' && getCurrentDropDownValue !== null) {
      _eChannelReporting = getCurrentDropDownValue;
      let disableItem = _eChannelReporting
      this.reportingEchannelDisableList = disableItem
      this.setState({
        reportedEChannelId: _eChannelReporting,
        disabledeChannelReporting: disableItem,
        eChannelReported: false
      }, () => {
        let localObj = {
          name: 'EChannelReporting',
          values: this.state
        }
        this.payloadEchannelReportingSection.setPaylod(localObj);
        this.payload.setPaylod(localObj);
      });
    }

    window.sessionStorage.removeItem('key' + getCurrentDropDown);
    window.sessionStorage.removeItem("getCurrentDropDown");
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getInterestPeriodSettlementDate();
    }

    let disableItem = this.state.reportedEChannelId
    this.reportingEchannelDisableList = disableItem
    this.setState({
      reportedEChannelId: this.state.reportedEChannelId,
      disabledeChannelReporting: disableItem
    });

  }


  handleSweepParticipantsRadioChange = (value, name) => {
    this.setState({
      isIERequired: value
    });
    //this.props.isSweepOrderRequired(value);
  }
  getInterestPeriodSettlementDate = () => {
    if (this.state.formJson) {
      this.dataDictionaryURI = this.translations(this.state.formJson.par && this.state.formJson.par.aemform_otherSettings.settlementDateTaxonomy);
      let eChannels = this.state.eChannels;
      taxonomyHostClient(this.translations(this.state.formJson.par.aemform_echannelReporting.countryTaxonomy))
        .then(({ data }) => {
          if (data.responseData !== undefined) {
            let currentListCountries = data.responseData.classificationNodes;
            if (eChannels !== undefined) {
              eChannels = eChannels.map(item => {
                currentListCountries.filter(countItem => {
                  if ('country' in item) {
                    if (countItem.id === item.country.value) {
                      item.country.name = countItem.name
                    }
                  }
                  return item;
                });

                this.setState([...eChannels]);
              });
            }
          }
        });
    }
  }

  getBasicDetails = (basicDetails) => {
    let localpayloadBlockObject = { name: "basicDetails", values: basicDetails }
    this.setState({ notionalPoolingTitle: basicDetails.notionalPoolingTitle });
    this.payload.setPaylod(localpayloadBlockObject);
    this.payloadBasicDetail.setPaylod(localpayloadBlockObject)
  }

  populateData = () => {
    /*api call for Notaionl Pooling Data*/
    eapiClient(this.apiURL, { method: 'GET' })
      .then(({ data }) => {
        this.props.setProductNotionalPooling(data.responseData);
        if (this.props.notionalPoolingdata.notionalPooling !== undefined) {
          var poolID = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools.map(item => item.id)
          var standID = this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount.map(item => item)

          var allAcc = this.props.notionalPoolingdata.notionalPooling.interestOptimisations;
          if (allAcc !== undefined && allAcc !== null && poolID !== undefined && standID !== undefined) {
            var myPool = allAcc.filter((item) => poolID.includes(item.id));
            var myStand = allAcc.filter((item) => standID.includes(item.id));
            //return this.state.interestOptimisations.map(this.renderInterestOptimization);
            this.setState({
              poolID: myPool,
              standID: myStand
            })
          }
        }
        this.setState({
          dataReady: true,
          notionalPoolingTitle: this.props.notionalPoolingdata.notionalPoolingTitle,
          interestOptimisations: this.props.notionalPoolingdata.notionalPooling.interestOptimisations || []
        })
        let localpayloadBlockObject = {
          name: "interestOptimisations",
          values: myPool.concat(myStand)
        }
        this.payload.setPaylod(localpayloadBlockObject);
        this.payloadInterestOptimization.setPaylod(localpayloadBlockObject);

        this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
      });
  }

  opneDeletePool = (e, id) => {

    if (id !== '') {
      let apiURLForTabStaus;
      let { caseId, productId } = this.props.match.params;
      eapiClient(this.apiURLDeletePool + id, {
        method: "DELETE"
      })
        .then(({ data }) => {
          this.loadTabStatus()
          this.populateData();
        });
    }
    this.setState({
      isdeletePool: false
    })
  }

  closeDeletePool = () => {
    this.setState({
      isdeletePool: false
    })
  }

  deletePool = (e, id) => {
    this.setState({
      isdeletePool: true,
      currentDeletePoolId: id
    });
  }

  opneDeleteStandAlone = (e, id) => {
    var standAloneAccounts = this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount || [];
    var interestOptimisations = this.props.notionalPoolingdata.notionalPooling.interestOptimisations || [];
    let interestOptimisationsArr = [];
    var standAloneAccountsFiltered;
    if (standAloneAccounts.length > 0) {
      var status = true;
      if (standAloneAccounts.length === 1 && standAloneAccounts[0] === id) {
        standAloneAccountsFiltered = [];
      } else {
        standAloneAccountsFiltered = standAloneAccounts.filter(
          function (filterId) {
            if (filterId === id && status) {
              status = false;
              return false;
            } else {
              return true;
            }

          }.bind(this));
      }

      interestOptimisations.filter((item) => {
        if (item.id !== id) {
          interestOptimisationsArr.push(item)
        }
      });

      var requestedPayload = {
        id: this.props.notionalPoolingdata.id,
        lid: this.props.notionalPoolingdata.lid,
        notionalPooling: {
          poolingStructure: {
            standAloneAccount: standAloneAccountsFiltered
          },
          interestOptimisations: interestOptimisationsArr
        }
      }
    }
    if (id !== '') {
      eapiClient(this.apiURL, {
        method: "PUT",
        data: JSON.stringify(requestedPayload)
      })
        .then(({ data }) => {
          this.populateData();
          this.loadTabStatus();
        });
    }
    this.setState({
      isdeleteStandAlone: false
    })
  }
  closeDeleteStandAlone = () => {
    this.setState({
      isdeleteStandAlone: false
    })
  }
  deleteStandAlone = (e, id) => {
    this.setState({
      isdeleteStandAlone: true,
      currentDeleteStandAloneId: id
    });
  }

  getData = (data) => {
    this.payload.setPaylod(data);
    this.payloadOtherSetting.setPaylod(data);
  }

  getInterestOptimizationData = (index, interestOptimizationData) => {
    var interestOptimisations = [...this.state.interestOptimisations];
    interestOptimisations.filter((interestOpt, index) => {
      if (interestOpt.id === interestOptimizationData.id) {
        interestOptimisations[index] = interestOptimizationData;
      }

    })
    this.setState({ interestOptimisations });
    let localpayloadBlockObject = {
      name: "interestOptimisations",
      values: interestOptimisations
    }
    this.payload.setPaylod(localpayloadBlockObject);
    this.payloadInterestOptimization.setPaylod(localpayloadBlockObject)
  }

  getInterestOptimizationDataOnNoSelection = () => {
    var interestOptimisations = [...this.state.interestOptimisations];
    let localpayloadBlockObject = {
      name: "interestOptimisations",
      values: interestOptimisations
    }
    this.payload.setPaylod(localpayloadBlockObject);
    this.payloadInterestOptimization.setPaylod(localpayloadBlockObject)
  }
  renderInterestOptimization = (account, index, key) => {
    var formData = {};
    if (account !== undefined && account.id !== undefined) {
      formData = { ...account }
      let glsReports = []
      let productParticipatingIn = {}
      if ("iban" in account === false) {
        formData['iban'] = '';
      }

      if (!("internalAccountNumber" in account)) {
        const standAloneAccountData = index.includes("stand") && this.props.basicDetailsAccounts && this.props.basicDetailsAccounts.length &&
          this.props.basicDetailsAccounts.find(acc => acc.id === account.id)
        formData['internalAccountNumber'] = (standAloneAccountData && standAloneAccountData.accountNumber) || ''
      }

      if ("extAccountNumber" in account === false) {
        formData['extAccountNumber'] = ''
      }

      if ('glsReports' in formData === false) {
        formData.glsReports = glsReports;
      }

      if (!('productParticipatingIn' in formData)) {
        const poolProductParticipatingIn = index.includes("pool") && this.props.notionalPoolingdata && this.props.notionalPoolingdata.notionalPooling &&
          this.props.notionalPoolingdata.notionalPooling.poolingStructure && this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools &&
          this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools[key] && this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools[key].allocationSettings &&
          this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools[key].allocationSettings.productParticipatingIn
        formData.productParticipatingIn = poolProductParticipatingIn && poolProductParticipatingIn.name && poolProductParticipatingIn.name.includes("Multi Currency Pool") ? poolProductParticipatingIn : productParticipatingIn;
      }

      if ("coveredCreditBalance" in account) {
        if ("rate" in account.coveredCreditBalance === false) {
          formData.coveredCreditBalance = {
            rate: false
          }
        }
      } else {
        formData['coveredCreditBalance'] = {
          rate: 'fixed'
        }
      }
      if ("coveredDebitBalance" in account) {
        if ("rate" in account.coveredDebitBalance === false) {
          formData.coveredDebitBalanc = {
            rate: false
          }
        }
      } else {
        formData['coveredDebitBalance'] = {
          rate: 'fixed'
        }
      }
      if ("residualDebitBalance" in account) {
        if ("rate" in account.residualDebitBalance === false) {
          formData.residualDebitBalance = {
            rate: false
          }
        }
      } else {
        formData['residualDebitBalance'] = {
          rate: 'fixed'
        }
      }
      if ("residualCreditBalance" in account) {
        if ("rate" in account.residualCreditBalance === false) {
          formData.residualCreditBalance = {
            rate: false
          }
        }
      } else {
        formData['residualCreditBalance'] = {
          rate: 'fixed'
        }
      }
      if ("unAuthorisedOD" in account) {
        if ("rate" in account.unAuthorisedOD === false) {
          formData.unAuthorisedOD = {
            rate: 'fixed'
          }
        }
        if ("interestRateType" in account.unAuthorisedOD === false) {
          formData.unAuthorisedOD = {
            interestRateType: "baseRate"
          }
        }
      } else {
        formData['unAuthorisedOD'] = {
          rate: 'fixed',
          interestRateType: "baseRate"
        }
      }
      if ("unauthorizedInterestType" in account === false) {
        formData.unauthorizedInterestType = "floating"
      }
    }
    else {
      formData['iban'] = '';
      formData['internalAccountNumber'] = '';
      formData['extAccountNumber'] = '';
      formData.glsReports = glsReports;
      formData.productParticipatingIn = productParticipatingIn;
      formData['coveredCreditBalance'] = {
        rate: 'fixed'
      }
      formData['coveredDebitBalance'] = {
        rate: 'fixed'
      }
      formData['residualDebitBalance'] = {
        rate: 'fixed'
      }
      formData['residualCreditBalance'] = {
        rate: 'fixed'
      }
      formData['unAuthorisedOD'] = {
        rate: 'fixed',
        interestRateType: "baseRate"
      }
      formData['unauthorizedInterestType'] = "floating"
      formData['odLimit'] = 'N/A'
    }
    //Account Details of Pool and StandAlone accountType Start
    var formHeader = (<div></div>);
    if (typeof this.props.basicDetailsAccounts !== 'undefined') {
      let filterAcc = this.props.basicDetailsAccounts.filter(acc => acc.id === account.id);
      if (typeof filterAcc[0] !== 'undefined') {
        let filAcc = filterAcc[0];
        if (filAcc !== 'undefined') {
          formHeader = (
            <div className="form-header">
              <div className='interset-opt-wrap'>
                <div className="stand-acc-header"><b>{this.translations(this.props.pageJson1.standaloneAccount)}</b></div>
                <div className="linkCursorHeader stand-acc-details">
                  <span>
                    {
                      filAcc.otherAccount !== undefined && 'otherAccount' in filAcc && filAcc.otherAccount === true
                        ? <b>
                          {`${filAcc.accountNumber !== undefined ? filAcc.accountNumber + ',' : ''}`}
                          {`${filAcc.branchCode !== undefined ? filAcc.branchCode + ',' : ''}`}
                          {`${filAcc.country !== undefined && filAcc.country.name !== undefined ? filAcc.country.name + ',' : ''}`}
                          {`${filAcc.currency !== undefined && filAcc.currency.name !== undefined ? filAcc.currency.name : ''}`}
                        </b>
                        : <b>
                          {`${filAcc.accountType !== undefined ? filAcc.accountType.name + ',' : ''}`}
                          {`${filAcc.country !== undefined && filAcc.country.name !== undefined ? filAcc.country.name + ',' : ''}`}
                          {`${filAcc.currency !== undefined && filAcc.currency.name !== undefined ? filAcc.currency.name : ''}`}
                        </b>
                    }
                  </span>
                  <p>{`${filAcc.accountHolder !== undefined ? filAcc.accountHolder.name : ''}`}</p>
                  <p>{filAcc.accountTitle !== undefined ? `(${filAcc.accountTitle})` : ''}</p>
                </div>
              </div>
            </div>
          );
        }
      } else {
        let filterpool = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools.filter(pool => pool.id === account.id);
        if (typeof filterpool[0] !== 'undefined') {
          let filpool = filterpool[0];
          let accountLenght = filterpool[0].accounts.length || 0
          let poolCurrency = filterpool[0].poolCurrency;
          formHeader = (
            <div className="form-header intersetOptimisation">
              <ul>
                <li>{poolCurrency !== undefined ? `${poolCurrency.name} 'Pool' -` : ''}</li>
                <li>{this.translations(this.props.pageJson1.singleCurrency)}</li>
                <li>{poolCurrency !== undefined ? poolCurrency.name : ''}</li>
                <li>{accountLenght} {this.translations(this.props.pageJson1.accounts)}</li>
              </ul>
            </div>
          );
          // let interestOptimisationsData = this.props.notionalPoolingdata.notionalPooling.interestOptimisations.filter(interestOptimisations => interestOptimisations.id === account.id);
          // if(interestOptimisationsData[0] !== undefined){
          //   let filterinterestOptimisationsData = filterpool[0].allocationSettings;
          //   if('unauthorisedOD' in filterinterestOptimisationsData){
          //     formData.unAuthorisedOD = filterinterestOptimisationsData.unauthorisedOD;
          //   }
          //   setDiableFalg = true;
          // }
        }
      }
    }

    //Account Details of Pool and StandAlone accountType end
    const properties = {
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: `gls-np-interest-optimisation_${index}`,
      pathname: this.props.history.location.pathname
    };

    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_interestOptimisation !== undefined) {
      var aemform = this.state.formJson.par.aemform_interestOptimisation;
      var formRef = this.state.formJson.par.aemform_interestOptimisation.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <div className='npdetails-section'>
            <Dynamicform
              mode="edit"
              key={account.id}
              properties={properties}
              hideButtons={true}
              getFormData={this.getInterestOptimizationData.bind(this, index)}
              history={this.props.history}
              url={url}
              italyIndex={index}
              fieldPrefix={index}
              formHeader={formHeader}
              lang={this.props.lang.currentLang.lang}
              translatedData={this.props.lang.translatedData}
              pageState={this.state}
              navigatedFrom="gls-np-interest-optimization"
              reportingEchannels={(this.state.eChannels && this.state.eChannels.length &&
                this.state.eChannels.filter(eChannel => eChannel.eChannelType && eChannel.eChannelType.name === "HSBCnet")) || []}
              isEchannelRestricted={true}
              requiredFields={{
                "row1": ["eChannelType", "country"],
                "row2": ["profileOwner"],
                "row3": ["eChannelId"]
              }}
              formatters={{
                "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                "row2": [],
                "row3": []
              }}
              disabledList={this.state.interestOptimisations && this.state.interestOptimisations.find(ioAcc => ioAcc.id === account.id) &&
                this.state.interestOptimisations.find(ioAcc => ioAcc.id === account.id)["glsReports"] &&
                this.state.interestOptimisations.find(ioAcc => ioAcc.id === account.id)["glsReports"]}
              handleGlsReportingApplyToAll={(reportIndex, eChannelId) => {
                const newInterestOptimisations = [...this.state.interestOptimisations]
                newInterestOptimisations.forEach(account => {
                  if (reportIndex > -1 && account.glsReports) {
                    account.glsReports[reportIndex] = eChannelId
                  }
                })
                this.setState({
                  accountInterestLimits: newInterestOptimisations
                })
              }}
            />
          </div>
        );
      }
    }
  }

  renderPoolForm = (pool) => {

    if (pool !== undefined && pool.length > 0) {
      return pool.map((item, key) => this.renderInterestOptimization(item, key + 'pool', key));
    }
  }

  renderStandAlonForm = (stand) => {
    if (stand !== undefined && stand.length > 0) {
      return stand.map((item, key) => this.renderInterestOptimization(item, key + 'stand', key));
    }
  }

  toNextpage = () => {
    this.props.history.goBack();
  }

  // Render E-Channel Reporting Section
  renderReportingSection = () => {
    let reporting_Jsx = [];
    for (var i = 0; i < this.state.noOfReporting; i++) {
      reporting_Jsx.push(
        <div className="reporting-container">
          <div className="reporting-section">
            <label className="reporting-section_label">{this.translations(this.state.formJson.par.aemform_echannelReporting.eChannel)}</label>
            <div className="reporting-section_div">
              <MultiLineSelect
                defaultValue={this.translations(this.state.formJson.par.aemform_echannelReporting.pleaseSelect)}
                requiredFields={{
                  "row1": ["eChannelType", "country"],
                  "row2": ["profileOwner"],
                  "row3": []
                }}
                formatters={{
                  "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                  "row2": [],
                  "row3": []
                }}
                data={this.state.eChannels && this.state.eChannels.filter(echannel => echannel.eChannelType.name === "HSBCnet") || []}
                value={this.state.reportedEChannelId !== undefined ? this.state.reportedEChannelId : ''}
                disabledOptions={this.reportingEchannelDisableList}
                multiAccount={true}
                _onChange={this.handleReportingChange.bind(this, i)}
                isDisable={this.props.customer.roleDetails.customer || this.state.eChannelReported}
              />
              <span className="icon icon-add addicon" disabled={this.state.eChannelReported}></span>
              <PersistLink
                className="mrg-left"
                to={'/case-body/create-new-product-echannel/isEchannelRestricted'}
                history={this.props.history}
                state={this.state}
                data={`eChannelReporting${i}`}
                isDisable={this.props.customer.roleDetails.customer || this.state.eChannelReported}
              >
                {this.translations(this.state.formJson.par.aemform_echannelReporting.addEchannel)}
              </PersistLink>
            </div>
          </div>
        </div>
      )
    }
    return reporting_Jsx;
  }

  // E-channel Reporting handler
  handleReportingChange = (index, data) => {
    let eChannel = data.id;
    this.reportingEchannelDisableList.indexOf(data.id) === -1 && this.reportingEchannelDisableList.includes(data.id)
      ? this.reportingEchannelDisableList.push(data.id)
      : this.reportingEchannelDisableList

    this.reportingEchannelDisableList = data.id

    this.setState({
      reportedEChannelId: eChannel,
      eChannelReported: false
    }, () => {
      let localObj = {
        name: 'EChannelReporting',
        values: this.state
      }
      this.payloadEchannelReportingSection.setPaylod(localObj);
      this.payload.setPaylod(localObj);
    })
  }

  // setShouldReportToEchannel = (value, name) => {
  //   if (value === true) {
  //     this.setState({
  //       eChannelReported: value
  //     }, () => {
  //       var localObj = {
  //         name: 'EChannelReporting',
  //         values: this.state
  //       }
  //       this.payloadEchannelReportingSection.setPaylod(localObj);
  //       this.payload.setPaylod(localObj);
  //     });
  //   } else {
  //     this.setState({
  //       eChannelReported: value,
  //       reportedEChannelId: '',
  //       disabledeChannelReporting: []
  //     }, () => {
  //       var localObj = {
  //         name: 'EChannelReporting',
  //         values: this.state
  //       }
  //       this.payloadEchannelReportingSection.setPaylod(localObj);
  //       this.payload.setPaylod(localObj);
  //     });
  //     this.reportingEchannelDisableList = []
  //   }
  // }

  loadTabStatus = () => {
    /*api call for Tab Status*/
    let apiURLForTabStaus;
    let { caseId, productId } = this.props.match.params;
    if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined) {
      apiURLForTabStaus = `/product/gls/${productId}/notionalPoolStatus`
    } else {
      apiURLForTabStaus = `/product/gls/${productId}/notionalPoolStatus`
    }

    eapiClient(apiURLForTabStaus, { method: 'GET' })
      .then(({ data }) => {
        this.props.setStatus(data.responseData);
      });
  }

  // Basic Detail
  onBasicDetailTabDataSubmit = (event, apiUrl) => {
    let id = this.props.notionalPoolingdata.id;
    let lid = this.props.notionalPoolingdata.lid;
    let data = this.payloadBasicDetail.getPayload();
    let requestData = {
      ...data,
      id: id,
      lid: lid
    };
    if (this.props.mode === 'edit') {
      this.apiURL = this.apiURL + "/" + this.state.formData.id;
    }
    eapiClient(this.apiURL, {
      method: "PUT",
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.setProductNotionalPooling(data.responseData);
        this.loadTabStatus();
      });
  }

  // Save and Refresh Sumbit for Reporting Section
  onSubmitReportingSectionData = () => {
    let id = this.props.notionalPoolingdata.id;
    let lid = this.props.notionalPoolingdata.lid;
    let data = this.payloadEchannelReportingSection.getPayload();
    let requestData = {
      ...data,
      id: id,
      lid: lid
    };
    if (this.props.mode === 'edit') {
      this.apiURL = this.apiURL + "/" + this.state.formData.id;
    }

    eapiClient(this.apiURL, {
      method: 'PUT',
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.setProductNotionalPooling(data.responseData);
        this.loadTabStatus();
      });
  }

  // Other setting
  onOtherSettingTabDataSubmit = () => {
    let id = this.props.notionalPoolingdata.id;
    let lid = this.props.notionalPoolingdata.lid;
    let data = this.payloadOtherSetting.getPayload();
    let requestData = {
      ...data,
      id: id,
      lid: lid
    };
    if (this.props.mode === 'edit') {
      this.apiURL = this.apiURL + "/" + this.state.formData.id;
    }
    eapiClient(this.apiURL, {
      method: "PUT",
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.setProductNotionalPooling(data.responseData);
        this.loadTabStatus();
      });
  }

  // Interest Optimization Section
  onInterestOptimizationTabDataSubmit = () => {
    let id = this.props.notionalPoolingdata.id;
    let lid = this.props.notionalPoolingdata.lid;
    let data = this.payloadInterestOptimization.getPayload();
    if (this.state.isIERequired !== undefined) {
      data.notionalPooling.isIERequired = this.state.isIERequired
    }
    let requestData = {
      ...data,
      id: id,
      lid: lid
    };

    if (requestData.notionalPooling && requestData.notionalPooling.interestOptimisations && requestData.notionalPooling.interestOptimisations.length) {
      let pools = requestData.notionalPooling.interestOptimisations;
      if (pools.length > 0) {
        for (let i = 0; i < pools.length; i++) {
          if (pools[i].productParticipatingIn && !pools[i].productParticipatingIn.name) {
            delete pools[i].productParticipatingIn
          }
        }
      }
    }

    if (this.props.mode === 'edit') {
      this.apiURL = this.apiURL + "/" + this.state.formData.id;
    }
    eapiClient(this.apiURL, {
      method: "PUT",
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.setProductNotionalPooling(data.responseData);
        this.loadTabStatus();
      });
  }

  // Main payload submit
  onFormSubmit = (event) => {
    let id = this.props.notionalPoolingdata.id;
    let lid = this.props.notionalPoolingdata.lid;
    let data = this.payload.getPayload();
    if (this.state.isIERequired !== undefined) {
      data.notionalPooling.isIERequired = this.state.isIERequired
    }
    if (data.notionalPooling.interestOptimisations === undefined || data.notionalPooling.interestOptimisations === null || data.notionalPooling.interestOptimisations.length === 0) {
      delete data.notionalPooling.isIERequired;
    }
    let requestData = {
      ...data,
      id: id,
      lid: lid
    };
    if (requestData.notionalPooling && requestData.notionalPooling.interestOptimisations && requestData.notionalPooling.interestOptimisations.length) {
      let pools = requestData.notionalPooling.interestOptimisations;
      if (pools.length > 0) {
        for (let i = 0; i < pools.length; i++) {
          if (pools[i].productParticipatingIn && !pools[i].productParticipatingIn.name) {
            delete pools[i].productParticipatingIn
          }
        }
      }
    }
    if (this.props.mode === 'edit') {
      this.apiURL = this.apiURL + "/" + this.state.formData.id;
    }
    eapiClient(this.apiURL, {
      method: "PUT",
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.history.goBack();
      });
  }

  setODLimit = (event) => {
    const updatedOtherSettings = {
      checkODLimit: event.target.checked,
      odLimit: event.target.checked ? 'N/A' : ''
    }
    if (event.target.checked) {
      updatedOtherSettings.unauthorisedOD = this.getInitialUnauthorisedODObject()
    }
    this.setState(updatedOtherSettings, () => this.setMyValue())
  }

  onChangeBaseCurrency = (event) => {
    let str = event.target.value;
    var res = str.split(":");
    let localObj = {
      name: 'otherSettings',
      values: {
        frequencyInfo: this.state.frequencyInfo,
        baseCurrency: {
          name: res[res.length - 1],
          value: event.target.value,
        }
      }
    }

    this.setState({
      selectedBaseCurrency: event.target.value
    });
    this.getData(localObj);
  }

  setFormElementData = (data) => {
    this.setState({
      frequencyInfo: data
    })

    let localObj = {
      name: 'otherSettings',
      values: {
        frequencyInfo: data,
        baseCurrency: {
          name: this.state.selectedBaseCurrency,
          value: this.state.selectedBaseCurrency
        }
      }
    }
    this.getData(localObj);
  }
  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      if (i !== 'undefined') {
        newArray.push(lookupObject[i]);
      }
    }
    return newArray;
  }
  _getData = (event) => {

    switch (event.target.name) {
      case 'odLimit':
        this.setState({
          odLimit: checkIsNA(event.target.value),
          checkODLimit: checkIsNA(event.target.value, true)
        }, () => this.setMyValue());
        break;
      case 'unauthorisedODbaseRate':
        this.setState({
          unauthorisedOD: {
            ...this.state.unauthorisedOD,
            baseRate: event.target.value
          }
        }, () => this.setMyValue())
        break;
      case 'unauthorisedODCode':
        this.setState({
          unauthorisedOD: {
            ...this.state.unauthorisedOD,
            baseRateCode: event.target.value
          }
        }, () => this.setMyValue())
        break;
      case 'unauthorisedODSpread':
        this.setState({
          unauthorisedOD: {
            ...this.state.unauthorisedOD,
            spread: event.target.value
          }
        }, () => this.setMyValue())
        break;
      case 'unauthorisedODMinInterest':
        this.setState({
          unauthorisedOD: {
            ...this.state.unauthorisedOD,
            minimumInterest: event.target.value
          }
        }, () => this.setMyValue())
        break;
      case 'unauthorisedODMaxInterest':
        this.setState({
          unauthorisedOD: {
            ...this.state.unauthorisedOD,
            maximumInterest: event.target.value
          }
        }, () => this.setMyValue())
        break;
    }
  }


  setMyValue = () => {
    let localObj = {
      name: 'otherSettings',
      values: {
        frequencyInfo: this.state.frequencyInfo,
        baseCurrency: {
          name: this.state.selectedBaseCurrency,
          value: this.state.selectedBaseCurrency
        },
        odLimit: this.state.odLimit,
        unauthorisedOD: this.state.unauthorisedOD,
        unauthorizedInterestTypeFloating: this.state.unauthorizedInterestTypeFloating,
        unauthorizedInterestTypeFixed: this.state.unauthorizedInterestTypeFixed,
      }
    }

    this.getData(localObj);
  }

  setInputvalue = (name, value, event) => {
    if (name === 'unauthorizedInterestTypeFloating') {
      this.setState({
        unauthorizedInterestTypeFloating: value,
        unauthorizedInterestTypeFixed: '',
      }, () => this.setMyValue())
    } else if (name === 'unauthorizedInterestTypeFixed') {
      this.setState({
        unauthorizedInterestTypeFloating: '',
        unauthorizedInterestTypeFixed: value,
      }, () => this.setMyValue())
    } else if (name === 'unauthorisedODFixedValue') {
      this.setState({
        unauthorisedOD: {
          ...this.state.unauthorisedOD,
          fixedValue: value,
          marginBaseRate: ''
        }
      }, () => this.setMyValue())
    } else if (name === 'unauthorisedODMarginBaseRate') {
      this.setState({
        unauthorisedOD: {
          ...this.state.unauthorisedOD,
          marginBaseRate: value,
          fixedValue: ''
        }
      }, () => this.setMyValue())
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  _checkboxHandler = (event) => {
    this.setState({
      eChannelReported: event.target.checked,
    }, () => {
      const echannelReportingObj = {
        name: 'EChannelReporting',
        values: this.state
      }
      this.payloadEchannelReportingSection.setPaylod(echannelReportingObj);
      this.payload.setPaylod(echannelReportingObj);
    });
  }

  getCCrRateId = (name, fieldPrefix = '', isAggregate, parentFormName, formIndex) => {
    return isAggregate ? `${fieldPrefix}${name}${parentFormName}${formIndex}Field` : `${fieldPrefix || ""}${name}Field`
  }

  generateCCRRateBoxJsx = ({ name, boxLabel, subLabels, subNames, radioValues, isVisible, maxChars, isAggregate, parentFormName, formData, formIndex, defaultValue }, elementKey = 'ccrratebox-ie-odlimit') => {
    const visibilityCss = classNames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const disabled = this.props.customer.roleDetails.customer
    const boxLabelTranslated = this.translations(boxLabel);
    const currentWord = this.translations(subLabels)
    const convertedArray = (typeof currentWord === "string" && convertStringToArrayForOption(currentWord)) || [];

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={this.getCCrRateId(name, this.props.fieldPrefix, isAggregate, parentFormName, formIndex)}>
        <div className="col-lg-12 col-sm-12">
          <CCRRateBox
            name={isAggregate ? parentFormName + name + formIndex : name}
            boxLabel={boxLabelTranslated}
            disabled={disabled}
            subLabels={convertedArray}
            subNames={subNames}
            radioValues={radioValues}
            maxChars={maxChars}
            defaultValue={defaultValue}
            _value={formData}
            setInputvalue={(values,) => {
              this.setState({ unauthorisedOD: { ...this.state.unauthorisedOD, ...values } }, () => this.setMyValue())
            }}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );
    return _jsx;
  }

  getInitialUnauthorisedODObject = () => ({
    baseRate: "",
    baseRateCode: "",
    spread: "",
    fixedValue: false,
    marginBaseRate: '',
    minimumInterest: '',
    maximumInterest: '',
    interestRateType: "baseRate"
  })

  getFrequencyInfoInitialValues = () => ({
    timeZone: null,
    frequencyType: {
      name: "Monthly",
      value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
    },
    frequencyDetails: {
      name: null,
      value: null
    },
    frequencyDetailValue: {
      name: null,
      value: null
    },
    annualDate: null,
    dates: []
  })

  render() {
    if (this.props.notionalPoolingdata !== undefined && this.props.notionalPoolingdata !== null && Object.keys(this.props.notionalPoolingdata).length > 0 && this.props.pageJsonAccordian !== undefined && this.state.json_echannelReporting !== undefined && this.props.pageJson1 !== undefined && this.props.pageJson2 !== undefined && this.props.statuses !== undefined
      && this.state.formJson !== undefined && this.props.pageJson2.defaultValue !== undefined) {
      const { notionalPoolingTitle, glsAgent, refrenceId } = this.props.notionalPoolingdata;
      const { accordion1, accordion2, accordion3, accordion4 } = this.props.pageJsonAccordian;
      var eChannelReporting = this.state.formJson.par.aemform_echannelReporting;
      const subLabels = ["Settlement date", "Settlement date"]
      const subNames = ["Settlement date", "Settlement date"];
      const fieldPrefix = "text7";
      let divJSX = ''
      if (this.state.formJson.par.staticText_InterestOptimisationrequired !== undefined) {
        divJSX = (
          <div className="form-group row">
            <label className="col-lg-4">
              {this.translations(this.state.formJson.par.staticText_InterestOptimisationrequired.InterestOptimisationReq)}
            </label>
            <div className="col-lg-8 col-sm-12">
              <div className="radiobtn">
                <div className="Radiocontainer">
                  <label className="radio-label">
                    {this.translateWord(this.state.formJson.par.staticText_InterestOptimisationrequired.options)[0].split('=')[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="isSweepOrderDefined"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.isIERequired}
                      value="true"
                    />
                  </label>
                </div>
              </div>
              <div className="radiobtn">
                <div className="Radiocontainer">
                  <label className="radio-label">
                    {this.translateWord(this.state.formJson.par.staticText_InterestOptimisationrequired.options)[1].split('=')[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="isSweepOrderDefined"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.isIERequired}
                      value="false"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        )
      }

      //onst  { baseRate, baseRateCode,spread,fixedValue,marginBaseRate,minimumInterest,maximumInterest } = this.state.unauthorisedOD
      const { unauthorizedInterestTypeFloating, unauthorizedInterestTypeFixed } = this.state

      document.title = refrenceId !== undefined
        ? `${"Product Requests"} - ${"Review Product"} - ${this.translations(this.state.formJson.par.page_title_mainTitle.pageHeading)} ${refrenceId} - ${'HSBC GLCM'}`
        : `${"Product Requests"} - ${"Review Product"} - ${"Notional Pooling"} - ${'HSBC GLCM'}`;
      return (
        <div className="customer-details-container gdocs-notional-pooling-container">
          <div className="pannel-heading-container">
            <div>
              <h2 className="pannel-heading">
                {this.translations(this.state.formJson.par.page_title_mainTitle.pageHeading)} <span>({refrenceId})</span>
              </h2>
            </div>
            <p className="pannel-sub-heading">
              {`${this.translations(this.props.pageJson1.agent)} : ${glsAgent.name}`} {notionalPoolingTitle !== undefined && notionalPoolingTitle !== '' ? `(${notionalPoolingTitle})` : ''}
            </p>
            <p className="optional-text">
              <b>{this.translations(this.props.pageJson1.descriptionText)}</b>
            </p>
          </div>
          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`1. ${this.translations(accordion1)}`}
              status={this.props.statuses.basicDetails !== undefined ? this.props.statuses.basicDetails.status : ''}
            >
              <div>
                {/*this.renderFormGroup()*/}
                <GlsNotionalPoolingBasicDetails
                  {...this.props}
                  formJson={this.state.formJson}
                  getBasicDetails={this.getBasicDetails}
                  dataReady={this.state.dataReady}
                  lang={this.props.lang}
                  saveRefreshClick={(event, apiUrl) => this.onBasicDetailTabDataSubmit(event, apiUrl)}
                />
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`2. ${this.translations(accordion2)}`}
              status={this.props.statuses.poolingStructure !== undefined ? this.props.statuses.poolingStructure.status : ''}
            >
              <div className="addresses-section">
                <div>
                  <GlsNotionalPoolingStrucutre
                    {...this.props}
                    pageJson={this.props.pageJson1}
                    deletePool={this.opneDeletePool}
                    deleteStandAloneAccount={this.opneDeleteStandAlone}
                    getData={this.getData}
                    lang={this.props.lang}
                    history={this.props.history}
                    isNavigate={this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate == true ? true : false}
                  />
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`3. ${this.translations(eChannelReporting.eChannelRep)}`}
              status={this.props.statuses.echannelReporting !== undefined ? this.props.statuses.echannelReporting.status : ''}
            >
              <div className="reporting">
                <p>
                  {this.translations(eChannelReporting.eChannelHSBCnetInfoone)}<br />
                  {this.translations(eChannelReporting.eChannelHSBCnetInfotwo)}
                </p>
                {this.renderReportingSection()}
                <div className={classNames("reporting-section", { "disabled": Boolean(this.state.reportedEChannelId) })}>
                  <label className="reporting-section_label">
                    {this.translations(eChannelReporting.eChannelCheckBox)}
                  </label>
                  <div
                    className="reporting-section_div"
                    role="radiogroup"
                    aria-label={this.translations(eChannelReporting.eChannelCheckBox)}
                  >
                    <Checkbox
                      name="eChannelReported"
                      id="eChannelReported"
                      checked={this.state.eChannelReported}
                      onChange={this._checkboxHandler}
                      disabled={Boolean(this.state.reportedEChannelId)}
                      controlled
                    />
                  </div>
                </div>

                <div className="gdocs-clear-float"></div>
                <div className="gdocs-float-right form-buttons-save-section">
                  <button onClick={this.onSubmitReportingSectionData} className='btn save-btn'>{this.translations(eChannelReporting.saveAndRefresh)}</button>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavListAccordion>

            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`4. ${this.translations(accordion3)}`}
              status={this.props.statuses.otherSettings !== undefined ? this.props.statuses.otherSettings.status : ''}
            >
              <div className="addresses-section">
                <div className="other-setting-container">
                  <div className="base-currency">
                    <label>{this.translations(this.props.pageJson2.baseCurrency)}</label>
                    <SimpleDropdown
                      name="baseCurrency"
                      defaultValue={this.translations(this.props.pageJson2.pleaseselect)}
                      disabled={this.props.customer.roleDetails.customer}
                      value={this.state.selectedBaseCurrency}
                      options={this.state.baseCurrency}
                      optionTextSelector="name"
                      valueSelector="name"
                      _onChange={this.onChangeBaseCurrency}
                    />
                    <div className="input-help-msg-section" style={{ width: '465px' }}>
                      {this.translations(this.props.pageJson2.baseDescription)}</div>
                  </div>
                  <div className="gdocs-clear-float"></div>
                  <div className="interest-period-wrapper">
                    {
                      <SweepFrequencyPicker
                        name={this.translations(this.props.pageJson2.settlementDate)}
                        boxLabel={this.translations(this.props.pageJson2.interestPeriod)}
                        mandatoryMessage={this.translations(this.props.pageJson2.validtimeentrymanmsg)}
                        subLabels={[this.translations(this.props.pageJson2.settlementDate), this.translations(this.props.pageJson2.settlementDate)]}
                        subNames={subNames}
                        dataDictionaryURI={this.dataDictionaryURI}
                        disabled={this.props.customer.roleDetails.customer}
                        setInputvalue={this.setFormElementData}
                        fieldPrefix={fieldPrefix}
                        _value={this.state.frequencyInfo}
                        lang={this.props.lang}
                        isCheckShow={false}
                      />
                    }
                  </div>
                  <div className="gdocs-clear-float"></div>
                  <div className="other-setting">
                    <div className="detail-setting--body-section-row">
                      <div className="od-limit-container">
                        <label>{this.translations(this.props.pageJson2.grpLimit)}</label>
                        <input
                          // ref={node => this[`disableODLimit`] = node}
                          className="od-row-input"
                          type="text"
                          onChange={(event) => this._getData(event)}
                          name="odLimit"
                          disabled={this.state.checkODLimit || this.props.customer.roleDetails.customer}
                          maxlength="10"
                          value={this.state.odLimit} />

                        <div className="gdocs-display-table gdocs-mleft-30">
                          <Checkbox
                            name={`set_ODLimit`}
                            disabled={this.props.customer.roleDetails.customer}
                            checked={this.state.checkODLimit}
                            onChange={(event) => this.setODLimit(event)}
                            controlled
                          />
                        </div>


                        <span className='gdocs-mleft-5'>{this.translations(this.props.pageJson2.na)}</span>
                      </div>
                    </div>
                    {/* {!this.state.checkODLimit &&
                      <div className="detail-setting--body-section-row">
                        <div className="">
                          <label>{this.translations(this.props.pageJson2.interestType)}</label>
                          <span className="gdocs-mleft-30">
                            <label className="radio-group gdocs-mright-30">
                              <Radiobutton
                                setInputvalue={this.setInputvalue.bind(this, 'unauthorizedInterestTypeFloating')}
                                name={`interestType`}
                                disabled={this.props.customer.roleDetails.customer}
                                value='true'
                                _value={unauthorizedInterestTypeFloating}
                              />
                              {this.translations(this.props.pageJson2.floating)}
                            </label>
                            <label className="radio-group">
                              <Radiobutton
                                setInputvalue={this.setInputvalue.bind(this, 'unauthorizedInterestTypeFixed')}
                                name={`interestType`}
                                disabled={this.props.customer.roleDetails.customer}
                                value='false'
                                _value={unauthorizedInterestTypeFixed}
                              />
                              {this.translations(this.props.pageJson2.fixed)}
                            </label>
                          </span>
                        </div>
                      </div>
                    } */}
                    {(this.state.checkODLimit === false || this.state.odLimit !== "N/A") && this.props.pageJson2 && this.props.pageJson2.guideccrrateUnauthorizedOD ?
                      <Fragment>
                        <h4>{this.translations(this.props.pageJson2.unauthorisedOd)}</h4>
                        {this.generateCCRRateBoxJsx({ ...this.props.pageJson2.guideccrrateUnauthorizedOD, formData: this.state.unauthorisedOD }, "ccrrate-gdocs-np")}
                      </Fragment>
                      : null}
                    {/* {!this.state.checkODLimit &&
                      <div className="detail-setting--body-section-row">
                        <div className="row-field">
                          <label>{this.translations(this.props.pageJson2.baserateCredit)}</label>
                          <input
                            type="text"
                            onChange={(event) => this._getData(event)}
                            name="unauthorisedODbaseRate"
                            disabled={this.props.customer.roleDetails.customer}
                            maxlength="50"
                            value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.baseRate : ''}
                          />
                        </div>
                        {!this.props.customer.roleDetails.customer
                          ? <div className="row-field">
                            <label>{this.translations(this.props.pageJson2.code)}</label>
                            <input
                              type="text"
                              onChange={(event) => this._getData(event)}
                              name="unauthorisedODCode"
                              maxlength="5"
                              placeholder={this.props.pageJson2.defaultValue && this.props.pageJson2.defaultValue[1]}
                              value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.baseRateCode : ''}
                            />
                          </div>
                          : ''}

                        <div className="row-field">
                          <label>{this.translations(this.props.pageJson2.spreadCredit)}</label>
                          <input
                            type="text"
                            onChange={(event) => this._getData(event)}
                            name="unauthorisedODSpread"
                            disabled={this.props.customer.roleDetails.customer}
                            maxlength="7"
                            value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.spread : ''}
                          />
                        </div>
                        <div className="row-field select-radio">
                          <label className="radio-group gdocs-mright-30">
                            <Radiobutton
                              name={`unauthorisedOD`}
                              disabled={this.props.customer.roleDetails.customer}
                              value='true'
                              _value={this.state.unauthorisedOD !== undefined ? this.state.unauthorisedOD.marginBaseRate : ''}
                              setInputvalue={this.setInputvalue.bind(this, 'unauthorisedODMarginBaseRate')}
                            />
                            {this.translations(this.props.pageJson2.margin)}
                          </label>
                          <label className="radio-group">
                            <Radiobutton
                              name={`unauthorisedOD`}
                              disabled={this.props.customer.roleDetails.customer}
                              value='false'
                              _value={this.state.unauthorisedOD !== undefined ? this.state.unauthorisedOD.fixedValue : ''}
                              setInputvalue={this.setInputvalue.bind(this, 'unauthorisedODFixedValue')}
                            />
                            {this.translations(this.props.pageJson2.fixedValue)}
                          </label>
                        </div>
                      </div>
                    }
                    {!this.state.checkODLimit &&
                      <div className="detail-setting--body-section-row">
                        <div className="row-field">
                          <label>{this.translations(this.props.pageJson2.minInterest)}</label>
                          <input
                            placeholder={this.props.pageJson2.defaultValue[5]}
                            type="text"
                            onChange={(event) => this._getData(event)}
                            name="unauthorisedODMinInterest"
                            disabled={this.props.customer.roleDetails.customer}
                            maxlength="10"
                            value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.minimumInterest : ''}
                          />
                        </div>
                        <div className="row-field">
                          <label>{this.translations(this.props.pageJson2.maxInterest)}</label>
                          <input
                            placeholder={this.props.pageJson2.defaultValue[6]}
                            type="text"
                            onChange={(event) => this._getData(event)}
                            name="unauthorisedODMaxInterest"
                            disabled={this.props.customer.roleDetails.customer}
                            maxlength="10"
                            value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.maximumInterest : ''}
                          />
                        </div>
                      </div>
                    } */}
                  </div>
                  <div className="gdocs-clear-float"></div>
                  <div key="buttons-wrapper" className="form-buttons-save-section">
                    <div className="form-buttons-wrapper">
                      <button
                        className="gdocs-btn-submit"
                        onClick={this.onOtherSettingTabDataSubmit}
                      >{this.translations(eChannelReporting.saveAndRefresh)}</button>
                    </div>
                  </div>
                </div>
              </div>
            </NavListAccordion>
            {/*  <NavListAccordion navAccHeading={`4. ${accordian4}`} status="optional">
            <div className="addresses-section">
            <div>
            <GlsNotionalPoolingInterestOptimization {...this.props} pageJson = {this.props.pageJson} getData ={this.getData}/>
            </div>
            </div>
            </NavListAccordion>
            */}
            {(this.props.notionalPoolingdata && this.props.notionalPoolingdata.notionalPooling && this.props.notionalPoolingdata.notionalPooling.poolingStructure) &&
              (this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools && this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools.length ||
                this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount.length) ?
              <NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`5. ${this.translations(accordion4)}`}
                status={this.props.statuses.interestOptimisation !== undefined ? this.props.statuses.interestOptimisation.status : ''}
              >
                <div className="addresses-section">
                  {divJSX}
                  {
                    this.state.isIERequired !== undefined && this.state.isIERequired && this.state.standID && this.state.standID.length > 0
                      ? this.renderStandAlonForm(this.state.standID)
                      : ((this.state.isIERequired !== undefined && !this.state.isIERequired)
                        || (this.props.notionalPoolingdata.notionalPooling.interestOptimisations && this.props.notionalPoolingdata.notionalPooling.interestOptimisations.length) > 0
                        ? this.getInterestOptimizationDataOnNoSelection() : '')
                  }
                  {
                    this.state.isIERequired !== undefined && this.state.isIERequired && this.state.poolID && this.state.poolID.length > 0
                      ? this.renderPoolForm(this.state.poolID)
                      : ((this.state.isIERequired !== undefined && !this.state.isIERequired)
                        || (this.props.notionalPoolingdata.notionalPooling.interestOptimisations && this.props.notionalPoolingdata.notionalPooling.interestOptimisations.length) > 0
                        ? this.getInterestOptimizationDataOnNoSelection() : '')
                  }
                  <div className="gdocs-clear-float"></div>
                  <div key="buttons-wrapper" className="form-buttons-save-section">
                    <div className="form-buttons-wrapper">
                      <button
                        className="gdocs-btn-submit"
                        onClick={this.onInterestOptimizationTabDataSubmit}
                      >{this.translations(eChannelReporting.saveAndRefresh)}</button>
                    </div>
                  </div>
                </div>
              </NavListAccordion> : ''}
          </NavListAccordionWrapper>
          <div className="save-btn-right">
            <button
              onClick={this.onFormSubmit}
              className='btn save-btn'
            >
              {this.translations(this.props.pageJson1.saveReturn)}
            </button>
          </div>
        </div>
      )
    } else {
      return (<div>Something went wrong</div>);
    }
  }
}

// Basic Detail Payload
class basicDetailPayload {
  constructor() {
    this.data = {}
    this.data.notionalPooling = {
      poolingStructure: null,
      interestOptimisations: null,
      otherSettings: null
    }
  }

  setPaylod(data) {
    switch (data.name) {
      case 'basicDetails':
        const { location, glsAgent, notionalPoolingTitle } = data.values;
        this.data.location = location;
        this.data.glsAgent = glsAgent;
        this.data.notionalPoolingTitle = notionalPoolingTitle;
        break;
      default:
    }
  }
  getPayload() {
    return this.data;
  }
}

// Other setting payload
class otherSettingPayload {
  constructor() {
    this.data = {}
    this.data.notionalPooling = {
      poolingStructure: null,
      interestOptimisations: null,
      otherSettings: null
    }
  }

  setPaylod(data) {
    switch (data.name) {
      case 'otherSettings': {
        this.data.notionalPooling.otherSettings = { ...this.data.notionalPooling.otherSettings, ...data.values };
      }
        break;
      default:
        return this.data.notionalPooling.otherSettings = {
          unauthorizedInterestTypeFloating: true,
          frequencyInfo: {
            timeZone: null,
            frequencyType: {
              name: "Monthly",
              value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
            },
            frequencyDetails: {
              name: null,
              value: null
            },
            frequencyDetailValue: {
              name: null,
              value: null
            },
            annualDate: null,
            dates: []
          }
        }
    }
  }
  getPayload() {
    return this.data;
  }
}

// interest optimization payload
class interestOptimizationPayload {
  constructor() {
    this.data = {}
    this.data.notionalPooling = {
      poolingStructure: null,
      interestOptimisations: null,
      otherSettings: null
    }
  }
  setPaylod(data) {
    switch (data.name) {
      case 'interestOptimisations':
        this.data.notionalPooling.interestOptimisations = data.values;
        break;
      default:
    }
  }
  getPayload() {
    return this.data;
  }
}

// E-Channel Reporting Section Payload
class EchannelReportingSection {
  constructor() {
    this.data = {}

    this.data.notionalPooling = {
      poolingStructure: null,
      eChannelReported: '',
      otherSettings: null,
      reportedEChannelId: ''
    }
  }
  setPaylod(data) {
    switch (data.name) {
      case 'EChannelReporting':
        const { eChannelReported, reportedEChannelId } = data.values
        this.data.notionalPooling.eChannelReported = eChannelReported;
        this.data.notionalPooling.reportedEChannelId = reportedEChannelId;
    }
  }

  getPayload() {
    return this.data;
  }
}
// setEchannelReporting({associationData}){
//   this.data.eChannelReporting = associationData;
//  }
// Main payload
class NotionalPoolingPayload {
  constructor() {
    this.data = {}
    this.data.notionalPooling = {
      poolingStructure: null,
      interestOptimisations: null,
      otherSettings: null
    }

  }
  setPrePopulateData(poolingStructure) {
    this.data.notionalPooling.poolingStructure = poolingStructure;
    // this.data.notionalPooling.otherSettings = {
    //   unauthorizedInterestTypeFloating: true,
    //   frequencyInfo: {
    //     timeZone: null,
    //     frequencyType: {
    //       name: "Monthly",
    //       value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
    //     },
    //     frequencyDetails: {
    //       name: null,
    //       value: null
    //     },
    //     frequencyDetailValue: {
    //       name: null,
    //       value: null
    //     },
    //     annualDate: null,
    //     dates: []
    //   }
    // }
  }
  setPaylod(data) {
    switch (data.name) {
      case 'basicDetails':
        const { location, glsAgent, notionalPoolingTitle } = data.values;
        this.data.location = location;
        this.data.glsAgent = glsAgent;
        this.data.notionalPoolingTitle = notionalPoolingTitle;
        break;
      case 'interestOptimisations':
        this.data.notionalPooling.interestOptimisations = data.values;
        break;
      case 'otherSettings':
        this.data.notionalPooling.otherSettings = { ...this.data.notionalPooling.otherSettings, ...data.values };
        break;
      case 'EChannelReporting':
        const { eChannelReported, reportedEChannelId } = data.values
        this.data.notionalPooling.eChannelReported = eChannelReported;
        this.data.notionalPooling.reportedEChannelId = reportedEChannelId;
        break;
      default:
    }
  }
  getPayload() {
    return this.data;
  }
}

const mapStateToProps = state => {
  return {
    notionalPoolingdata: state.currentProductNotionalPooling.data,
    statuses: state.currentProductNotionalPooling.statuses,
    currency: state.currentProductNotionalPooling.currency,
    basicDetailsAccounts: state.currentProductNotionalPooling.accounts,
    cases: state.cases,
    pageJson1: state.currentProductNotionalPooling.pageJson1,
    pageJson2: state.currentProductNotionalPooling.pageJson2,
    pageJsonAccordian: state.currentProductNotionalPooling.pageJsonAccordian,
    dataIOFormJson: state.currentProductNotionalPooling.dataIOFormJson,
    interestPeriodSettlementDate: state.currentProductNotionalPooling.interestPeriodSettlementDate,
    lang: state.lang,
    poolIdAfterSaveRefresh: state.currentProductNotionalPooling.poolIdAfterSaveRefresh,
    customer: state.auth.userDetails
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setProductNotionalPooling: data => {
      dispatch(setProductNotionalPooling(data))
    },
    setStatus: statuses => {
      dispatch(setStatus(statuses))
    },
    setPartyCurrency: currency => {
      dispatch(setPartyCurrency(currency))
    },
    setBasicDetailAcc: accounts => {
      dispatch(setBasicDetailAcc(accounts))
    },
    setPageJson: par => {
      dispatch(setPageJson(par))
    },
    setPageJson1: par => {
      dispatch(setPageJson1(par))
    },
    setPageJson2: par => {
      dispatch(setPageJson2(par))
    },
    setPageJsonAccordian: par => {
      dispatch(setPageJsonAccordian(par))
    },
    setFormDataInterestOptimization: dataIO => {
      dispatch(setFormDataInterestOptimization(dataIO))
    },
    interestPeriodSettlementDate: date => {
      dispatch(interestPeriodSettlementDate(date));
    },
    resetPoolIdAfterSaveReferesh: () => {
      dispatch(resetPoolIdAfterSaveReferesh());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductGlsNotionalPooling);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/index.js